import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Radio,
    RadioGroup,
    FormControlLabel,
    Button
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SortIcon from '@mui/icons-material/Sort';

const sortOptions = [
    { value: 'duration-asc', label: 'Shortest Duration' },
    { value: 'duration-desc', label: 'Longest Duration' },
    { value: 'lessons-asc', label: 'Fewest Lessons' },
    { value: 'lessons-desc', label: 'Most Lessons' }
];

const CourseSortBy = ({ sortBy, setSortBy, resetSortBy }) => {
    return (
        <Box sx={{
            backgroundColor: '#fff',
            borderRadius: 3,
            boxShadow: 'none',
            p: 3,
            mt: 3
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Box sx={{ display: 'flex' }}>
                    <SortIcon sx={{ alignSelf: 'center', mr: '5px' }} />
                    <Typography variant="subtitle1" sx={{
                        fontWeight: 'bold',
                        fontFamily: "'Satoshi', sans-serif",
                        fontSize: '1.2rem',
                        alignSelf:'center'
                    }}>
                        Sort By
                    </Typography>
                </Box>
                <Button
                    variant="text"
                    onClick={resetSortBy}
                    sx={{
                        color: '#7C3AED',
                        textTransform: 'none',
                        fontFamily: "'Satoshi', sans-serif",
                        fontWeight: 'bold'
                    }}
                >
                    Reset
                </Button>
            </Box>
            <Accordion
                sx={{
                    boxShadow: 'none',
                    '&:before': { display: 'none' },
                    fontFamily: "'Satoshi', sans-serif",
                }}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ fontWeight: 'bold' }}>Sort Options</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <RadioGroup
                        value={sortBy}
                        onChange={(e) => setSortBy(e.target.value)}
                    >
                        {sortOptions.map((option) => (
                            <FormControlLabel
                                key={option.value}
                                value={option.value}
                                control={
                                    <Radio
                                        size="small"
                                        sx={{
                                            color: '#7C3AED',
                                            '&.Mui-checked': {
                                                color: '#7C3AED'
                                            }
                                        }}
                                    />
                                }
                                label={option.label}
                                sx={{
                                    display: 'block',
                                    ml: 0,
                                    '& .MuiTypography-root': {
                                        fontFamily: "'Satoshi', sans-serif",
                                        fontSize: '0.875rem'
                                    }
                                }}
                            />
                        ))}
                    </RadioGroup>
                </AccordionDetails>
            </Accordion>
        </Box>
    );
};

export default CourseSortBy;